import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const rolesPermissionsAPI = createApi({
    reducerPath: "rolesPermissionsAPI",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["RolesPermissions"],
    endpoints: (builder) => ({
        getRolesPermissions: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/system-access/role/list?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["RolesPermissions"],
        }),
        getRolesPermissionsById: builder.query({
            query: (id) => `/system-access/role/view/${id}`,
            providesTags: ["RolesPermissions"],
        }),
        getModulesList: builder.query({
            query: () => `/system-access/permissions/modules`,
            providesTags: ["RolesPermissions"],
        }),

        saveRolesPermissions: builder.mutation({
            query: (payload) => ({
                url: `/system-access/role/create`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["RolesPermissions"],
        }),

        updateRolesPermissions: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/system-access/role/update/${id}`,
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["RolesPermissions"],
        }),

        deleteRolesPermissions: builder.mutation({
            query: (id) => ({
                url: `/system-access/role/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["RolesPermissions"],
        }),
    }),
});

export const {
    useGetRolesPermissionsQuery,
    useSaveRolesPermissionsMutation,
    useUpdateRolesPermissionsMutation,
    useDeleteRolesPermissionsMutation,
    useGetModulesListQuery,
    useGetRolesPermissionsByIdQuery
} = rolesPermissionsAPI;
